import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IDriver } from 'modules/inventory/provider/carriers/interfaces';

class DriverService extends EntityApiService<IDriver> {
  createDriver = (payload: Partial<IDriver>): any => {
    return this.handleResponse(ApiClientService.post(this.getPath(''), payload));
  };

  updateGeneral = (driverId: string, payload: Partial<IDriver>): any => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${driverId}/general`), payload));
  };

  updateContacts = (driverId: string, params?: any): any => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${driverId}/contacts`), params));
  };

  updateAddress = (driverId: string, params?: any): any => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${driverId}/address`), params));
  };

  updateLicense = (driverId: string, params?: any): any => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${driverId}/license`), params));
  };

  updateActive = (driverId: string, active: boolean): any => {
    return this.handleResponse(ApiClientService.patch(this.getPath(`/${driverId}/active`), { active }));
  };

  deleteDriver = (driverId: string): any => {
    return this.handleResponse(ApiClientService.delete(this.getPath(`/${driverId}`)));
  };

  getOne = (productId: string, config?: RequestConfig | undefined) => {
    const p = config?.pathOptions?.populate ? '?populate=true' : '';
    return this.handleResponse(ApiClientService.get(this.getPath(`/${productId}/${p}`), config));
  };
}

export default new DriverService('/ms-inventory/api/drivers');
